import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Button, Typography, makeStyles } from "@material-ui/core";

import { userRoleSelector } from "src/store/system/selector";
import { StatefulLoadableButton } from "src/components/LoadableButton";

const useStyles = makeStyles((theme) => ({
  errorButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));

function CompleteUpload({ render, onCancel, onSubmit, amount }: any) {
  const classes = useStyles();
  const userRole = useSelector(userRoleSelector);
  const [confirmCancel, setConfirmCancel] = useState(false);

  return render({
    title: "Confirm Matches",
    main: (
      <Typography variant="body1" paragraph>
        {confirmCancel
          ? "Are you sure you want to cancel the upload? All of your inventory matching work will be lost."
          : `Your ${amount} sales are ready to be matched to inventory. Click the “Submit” button to complete the matches.`}
      </Typography>
    ),
    actions: confirmCancel ? (
      <>
        <Button variant="contained" onClick={() => setConfirmCancel(false)}>
          No, Do Not Cancel
        </Button>
        <Button
          variant="contained"
          className={classes.errorButton}
          onClick={onCancel}
        >
          Cancel Match
        </Button>
      </>
    ) : (
      <>
        <Button
          variant="contained"
          className={classes.errorButton}
          onClick={() => setConfirmCancel(true)}
        >
          Cancel Upload
        </Button>
        <StatefulLoadableButton
          color="primary"
          variant="contained"
          onClick={onSubmit}
          disabled={userRole === "viewer"}
        >
          Submit
        </StatefulLoadableButton>
      </>
    ),
  });
}

export default CompleteUpload;
